import React, { Component } from 'react';

import './Page404.scss';

class Page404 extends Component {

    render() {
        
        return (<div className="page-404">
                <h1 className="page-title">Page Not Found</h1>
                <p className="prose">The page you are looking for does not exist.</p>
        </div>);
    };
};

export default Page404;
